// @ts-ignore
import React from "react";

import { MeResponse } from "@atlassiansox/asc-stargate";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";

import { AppPricingData } from "../../contentful";
import { ConfluenceSoftwarePageTemplate } from "../../templates/confluence-software-page/src";

export type ConfluenceSoftwarePageProps = {
    pricing?: AppPricingData;
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
};

export const ConfluenceSoftwarePage = (props: ConfluenceSoftwarePageProps) => (
    <ConfluenceSoftwarePageTemplate
        pricing={props.pricing}
        availableProducts={props.availableProducts}
        userProfile={props.userProfile}
    />
);
